import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import * as axios from 'axios';
import { withRouter } from 'react-router';

const proxyUrl = process.env.REACT_APP_FILING_READER_PROXY + '?url=';
const defaultFiling =
  'https://www.sec.gov/Archives/edgar/data/1627857/000156459019017247/sail-10q_20190331.htm';
const defaultLink = proxyUrl + defaultFiling;

const loadFiling = (url = defaultLink) => {
  const targetUrl = proxyUrl + url;
  console.log('Loading filing', targetUrl);
  return axios
    .get(targetUrl)
    .then(response => response.data)
    .catch(console.log);
};

const FilingWrapper = styled.div`
  display: flex;
  justify-content: center;
  //width: 100%;
`;

const FilingContainer = styled.div`
  box-sizing: border-box;

  @media only screen and (max-width: 850px) {
    padding: 10px;
    width: 100%;
  }

  @media only screen and (min-width: 850px) {
    padding: 2rem;
    max-width: 850px;
  }
`;

function _Filing({ location }) {
  const [html, setHtml] = useState('Loading...');
  const params = new URLSearchParams(location.search);
  const url = params.get('url');

  useEffect(
    () => {
      loadFiling(url).then(setHtml);
    },
    [url]
  );

  return (
    <FilingWrapper>
      <FilingContainer>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </FilingContainer>
    </FilingWrapper>
  );
}

const Filing = withRouter(_Filing);

export { Filing };
